import React from 'react';
import AtlasV2DorisDoubleDropdownChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisDoubleDropdownChart';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { useDorisEntityDropdownOptions } from 'src/components/AtlasV2Components/AtlasV2TrafficV2PageComponents/AtlasV2TotalTrafficV2/AtlasV2TotalTrafficDoubleDropdownTopEntity';
import { GroupByField } from 'src/components/AtlasV2Components/AtlasV2TrafficV2PageComponents/AtlasV2TotalTrafficV2/AtlasV2TrafficDropdownTopEntityTraffic';
import { useSalesCustomGroupBy } from 'src/components/AtlasV2Components/Hooks/useSalesCustomGroupBy';
import { DorisDropdownFieldNameEnum } from 'src/components/AtlasV2Components/Consts/DorisFieldNameEnum';
import { createLabelCaseProcessor } from 'src/components/AtlasV2Components/utils/chartDataTransformUtils';

const AtlasUnitsSoldDoubleDropdownTopEntityChart = ({
  groupByFields,
  enableSearchableGroupBy
}: {
  groupByFields?: GroupByField[];
  enableSearchableGroupBy?: boolean;
}) => {
  const dropdownOptions = useDorisEntityDropdownOptions(DorisDropdownFieldNameEnum.Sales);

  const { computedGroupByFields, selectedGroupByField, additionalParams, renderGroupBySelector } =
    useSalesCustomGroupBy({
      enabled: !!enableSearchableGroupBy,
      groupByFields: (groupByFields || dropdownOptions) as GroupByField[]
    });

  // Use shared utility to create preProcessData function - Product tagging data want to be lowercased
  const preProcessData = createLabelCaseProcessor(selectedGroupByField);

  return (
    <AtlasV2DorisDoubleDropdownChart
      groupByFields={computedGroupByFields}
      selectedGroupByField={selectedGroupByField}
      fields={[
        {
          fieldName: 'unitsSold',
          label: 'Units Sold',
          metricType: 'unitsSold',
          metricTypeDisplay: METRICTYPE.VOLUME
        },
        {
          fieldName: 'firstPartyUnitsSold',
          label: '1P Units Sold',
          metricType: 'firstPartyUnitsSold',
          metricTypeDisplay: METRICTYPE.VOLUME
        },
        {
          fieldName: 'thirdPartyUnitsSold',
          label: '3P Units Sold',
          metricType: 'thirdPartyUnitsSold',
          metricTypeDisplay: METRICTYPE.VOLUME
        }
      ]}
      queryKey="unitsSold_doubleDropdownTopEntityChart"
      endPoint="sales/GetSalesMetrics"
      additionalParams={additionalParams}
      renderGroupBySelector={renderGroupBySelector}
      preProcessData={preProcessData}
    />
  );
};
export default AtlasUnitsSoldDoubleDropdownTopEntityChart;
